/*
 * サブシステム名：マスタ管理
 * 機能名：発着地距離登録
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDateBox = () => import('@/components/DdDateBox')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstHacchakuchiKyoriEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDateBox,
    DdEditCommonBar,
    DdNumericBox,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},

    // ヘッダーリスト
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,

    modeOfEdit: 2,
    modeKengen: 2
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi'
    }),

    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hacchakuchiCd > elem2.hacchakuchiCd) { return 1 }
        if (elem1.hacchakuchiCd === elem2.hacchakuchiCd) { return 0 }
        return -1
      })
    },
    // 発着地マスタフィルター <-- ここまで

    isDeleteDisable () {
      return this.id === 0
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      console.log('★モード', this.modeOfEdit, this.modeKengen)
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        console.log('★true')
        return true
      }
      console.log('★false')
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        console.log('★fetchData', self)
        console.log('★going to get', self.id)
        console.log('@+@going to get', self.id)
        this.HttpClient
          .get(`/api/v1/MstHacchakuchiKyori/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload
            console.log('recived data', this.rec)
            resolve()
          })
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msttorihikisaki', 'msthacchakuchi'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {
              hatsuchiCd: null,
              chakuchiCd: null,
              torihikisakiCd: null,
              tekiyoStartYmdString: '2000/01/01',
              tekiyoEndYmdString: '2100/01/01',
              kyoriKm: '',
              hyojiOrder: '9999'
            }
            console.log('initializeInputPromise')
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            console.log('★savedInputRestorePromise', self.rec)
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            console.log('★savedInputRestorePromise', self.rec)
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }
            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('◇onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      console.log('◇cancelInput', e)
      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      console.log('@+@DeleteButtonClick')
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            console.log(`@+@DeleteButtonHttpClient = ${self.id}`)
            self.HttpClient.delete(`/api/v1/MstHacchakuchiKyori/Delete?id=${self.id}&tm=${self.rec.timestamp}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.sagyoJissekiNo = ''
          self.rec.sagyoJissekiNo = ''
          self.modeOfEdit = 0
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    onRirekiFukushaButtonClick: function (e) {
      console.log('onRirekiFukushaButtonClick', e)
    },
    onSaveButtonClick: function (e) {
      console.log('save', this)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.id !== this.rec.id
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            console.log('★transition')
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.post('/api/v1/MstHacchakuchiKyori/Create', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.put(`/api/v1/MstHacchakuchiKyori/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      console.log('validate start', this.cloneData)
      console.log('◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆', this.$refs)
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        console.log('tekiyoYmd')
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      console.log('validate OK')
      return true
    },
    deleteValidate: function () {
      return true
    }
  }
}
